export function Diamond2Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7 3a1 1 0 00-.832.445l-4 6a1 1 0 00.089 1.224l8.994 9.993a1.006 1.006 0 00.836.334 1 1 0 00.662-.334l8.994-9.993a1 1 0 00.09-1.224l-4-6A1 1 0 0017 3H7zm3.132 2H7.535L4.87 9h2.596l2.667-4zm-2.809 6H5.245l3.74 4.155L7.323 11zm7.692 4.155L18.755 11h-2.078l-1.662 4.155zM14.523 11L12 17.307 9.477 11h5.046zm-.391-2H9.869L12 5.803 14.132 9zm2.403 0l-2.667-4h2.597l2.666 4h-2.596z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
